/** RagNode — `rag.query` permission-aware retrieval node. */
import type { ReactNode } from 'react';
import type { NodeProps } from 'reactflow';
import { NODE_TYPES } from '../../lib/agents';
import { BaseNode, type BaseNodeData } from './BaseNode';

export function RagNode(props: NodeProps<BaseNodeData>): ReactNode {
  return <BaseNode {...props} nodeType={NODE_TYPES.RAG_QUERY} />;
}
